import { Component } from '@angular/core';

@Component({
  selector: 'app-no-access',
  imports: [],
  templateUrl: './app-no-access.html',
  styleUrl: './app-no-access.scss',
  standalone: true,
})
export class AppNoAccess {

}
